module.exports = __webpack_public_path__ + "img/20210906-1630912455666363.6cf505b2.png";